import { Link } from "react-router-dom";
import { BookOpen, Tag, HandshakeIcon, Eye } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface CardAdminProps {
  to: string;
  title: string;
  description: string;
  Icon: LucideIcon;
  colorClass: string;
  iconColorClass: string;
}

function CardAdmin({ to, title, description, Icon, colorClass, iconColorClass }: CardAdminProps) {
  return (
    <Link
      to={to}
      className="group flex flex-col overflow-hidden rounded-2xl bg-surface shadow-sm transition-all hover:-translate-y-1 hover:shadow-md sm:flex-row"
    >
      <div className={`flex items-center justify-center p-5 sm:w-28 ${colorClass}`}>
        <Icon className={`h-8 w-8 transition-transform group-hover:scale-110 ${iconColorClass}`} />
      </div>
      <div className="flex flex-1 flex-col justify-center p-5">
        <h3 className="font-bold text-text">{title}</h3>
        <p className="mt-1 text-sm text-muted">{description}</p>
        <div className="mt-3 flex items-center text-sm font-bold text-brand-verde">
          <span>Gerenciar</span>
          <svg className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </div>
      </div>
    </Link>
  );
}

export function DashboardAdmin() {

  return (
    <main className="mx-auto w-full max-w-4xl px-4 pb-12 pt-8 sm:px-6 sm:pt-10">
        <header className="mb-8 flex items-start justify-between gap-3">
          <div>
            <h1 className="text-2xl font-black tracking-tight text-brand-verde sm:text-3xl">
              Biblioteca
            </h1>
            <p className="mt-1 text-sm text-muted">
              Selecione uma área para gerenciar o acervo da biblioteca.
            </p>
          </div>
        </header>

        <div className="grid grid-cols-1 gap-4">
          <CardAdmin to="/admin/emprestimos" title="Empréstimos" description="Aprovar solicitações, registrar devoluções e controlar prazos." Icon={HandshakeIcon} colorClass="bg-success/10" iconColorClass="text-success" />
          <CardAdmin to="/admin/livros" title="Acervo de livros" description="Cadastrar novos títulos, atualizar estoque e gerenciar o catálogo." Icon={BookOpen} colorClass="bg-surface-2" iconColorClass="text-orange-500" />
          <CardAdmin to="/admin/categorias" title="Categorias" description="Organizar os livros por temas, gêneros e assuntos." Icon={Tag} colorClass="bg-surface-2" iconColorClass="text-purple-500" />
        </div>

        <Link
          to="/admin/visualizar-como-usuario"
          className="mt-4 flex items-center justify-center gap-2 rounded-2xl border border-dashed border-border bg-surface/50 p-4 text-sm font-medium text-muted transition-colors hover:border-brand-verde hover:text-brand-verde"
        >
          <Eye size={16} />
          Ver como membro
        </Link>
    </main>
  );
}
